// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-toggle="nav-mobile"]').on('click', (event) => {
  event.preventDefault();
  const $toggle = $(event.currentTarget);
  const $nav = $('.mobile-nav');
  const isVisible = $nav.hasClass('mobile-nav--visible');

  $toggle.toggleClass('hamburger--active');
  $nav.toggleClass('mobile-nav--visible');
  $nav.scrollTop(0);
  $('body, html').toggleClass('nav-mobile-is-visible');

  if (!isVisible) {
    // Hide items immediately
    const $items = $nav.find('li');
    $items.css({
      opacity: 0,
      transform: 'translateX(30px)'
    });

    // Animate only after menu transition completes
    $nav.one('transitionend', () => {
      $items.each((i, el) => {
        $(el)
          .delay(i * 120)
          .animate(
            { opacity: 1 },
            {
              duration: 400,
              step: (now, fx) => {
                if (fx.prop === 'opacity') {
                  $(el).css('transform', `translateX(${30 - now * 30}px)`);
                }
              }
            }
          );
      });
    });
  }
});

// Toggle nested menu items
$('.mobile-nav .caret').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this.removeClass('fa-angle-down').addClass('fa-angle-up');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this.removeClass('fa-angle-up').addClass('fa-angle-down');
  }
});

// Toggle nested menu items in footer
$('.mobile-nav__footer .page_item a').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this
      .siblings('.caret')
      .removeClass('fa-angle-down')
      .addClass('fa-angle-up');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this
      .siblings('.caret')
      .removeClass('fa-angle-up')
      .addClass('fa-angle-down');
  }
});
